module.exports = __webpack_public_path__ + "img/background06.2ac42bd8.jpg";